import { t } from 'i18next';
import * as yup from 'yup';

import { numberSchemaWithTransform } from 'core/yup';

export const quotePartUpdateMargin = () =>
  yup
    .object()
    .shape({
      computedPurchaseCost: numberSchemaWithTransform().label(t('labelPurchaseCost')).nullable(),
      price: numberSchemaWithTransform().label(t('labelPrice')).nullable(),
      margin: numberSchemaWithTransform()
        .label(t('labelMargin'))
        .nullable()
        .when('computedPurchaseCost', (computedPurchaseCost, schema) =>
          computedPurchaseCost > 0
            ? schema.test(
                'cannot-calculate-price',
                t('errorPriceCannotBeCalculatedByType', { type: '' }),
                (value) => !!value && value !== 0 && Number(value) !== 100
              )
            : schema
        ),
      computedPurchaseCostBase: numberSchemaWithTransform()
        .label(t('labelBasePurchaseCost'))
        .nullable(),
      priceBase: numberSchemaWithTransform().label(t('labelBasePrice')).nullable(),
      marginBase: numberSchemaWithTransform().label(t('labelBaseMargin')).nullable(),
      computedPurchaseCostAdder: numberSchemaWithTransform()
        .label(t('labelAdderPurchaseCost'))
        .nullable(),
      priceAdder: numberSchemaWithTransform().label(t('labelAdderPrice')).nullable(),
      marginAdder: numberSchemaWithTransform().label(t('labelAdderMargin')).nullable(),
      allSameBase: yup.boolean().nullable(),
    })
    .test(
      'computedPurchaseCostBase-or-computedPurchaseCostAdder',
      t('errorComputedPurchaseCostBaseAndAdderRequired'),
      function (value) {
        if (value.computedPurchaseCostBase && value.computedPurchaseCostAdder) {
          return true;
        }

        if (!value.computedPurchaseCostBase && !value.computedPurchaseCostAdder) {
          return true;
        }

        return false;
      }
    )
    .test('marginBase-or-marginAdder', t('errorMarginBaseAndAdderRequired'), function (value) {
      if (value.marginBase && value.marginAdder) {
        return true;
      }

      if (!value.marginBase && !value.marginAdder) {
        return true;
      }

      return false;
    });
